import React, { useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import dhoorbinOutline from "../../../../../assets/icons/dhoorbin-outline.svg";
import { blogs } from "../data/blog";
import { Link } from "react-router";
import { getBlogs } from "../../../../../api/website/blog/blogApi";

const Blogs = () => {
  const [BlogData, setBlogData] = useState("");

  useEffect(() => {
    getBlogs(setBlogData);
  }, []);
  return (
    <>
      {BlogData && (
        <>
          <div className="bg-white space-y-4 lg:space-y-0">
            <div className="lg:relative py-0 lg:py-16 block lg:flex flex-col justify-center items-center">
              <h2 className="font-bold text-xl lg:text-3xl text-[#2155ad] capitalize">
                Relax and Read Our Blogs
              </h2>
              <p className="text-xs text-black/50">
                Stay updated with the latest news and articles from our team
              </p>
              <div className="absolute hidden lg:block -top-16">
                <img width={300} src={dhoorbinOutline} alt="" />
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
              {BlogData.length > 0 ? (
                <>
                  {BlogData?.map((item, index) => {
                    return (
                      <div key={index}>
                        <Link
                          to={`/blog/${item.id}/${item.blogTitle
                            .toLowerCase()
                            .replace(/ /g, "-")}`}
                        >
                          <div className="bg-white shadow-none hover:shadow-lg rounded-md scale-100 hover:scale-105 duration-300 cursor-pointer">
                            <div className="w-full h-auto rounded-md border flex flex-col gap-y-2 p-2">
                              <div className="relative w-full h-50 rounded-md overflow-hidden">
                                <img
                                  className="w-full h-full object-cover scale-100 hover:scale-105 duration-300"
                                  src={item.featuredImage}
                                  alt=""
                                />
                                <div className="absolute top-2 right-2 text-xs bg-[#ff006286] text-white px-2 py-0.5 w-auto h-auto rounded-md cursor-pointer">
                                  {item.category_name}
                                </div>
                              </div>

                              <div className="space-y-2">
                                <p className="font-bold text-sm text-[#0d2d63]">
                                  {item.blogTitle}
                                </p>
                              </div>
                              <div>
                                <p className="text-xs text-black/80">
                                  {item.body
                                    .replace(/<[^>]+>/g, " ")
                                    .trim()
                                    .split(/\s+/)
                                    .slice(0, 10)
                                    .join(" ") + "..."}
                                </p>
                              </div>

                              <div className="pt-3 flex justify-between items-center">
                                <div className="flex items-center justify-start gap-x-1">
                                  <p className="text-xs text-black/80">
                                    {new Date(item.createdAt).toLocaleString(
                                      "en-US",
                                      {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric",
                                      }
                                    )}
                                  </p>
                                </div>
                                <div className="flex items-center gap-x-1 border px-1 py-0.5 rounded-md cursor-pointer  scale-100 hover:scale-105 duration-300">
                                  <div>
                                    <p className="text-xs text-black">
                                      Read Now
                                    </p>
                                  </div>
                                  <div className="text-xs text-black">
                                    <IoIosArrowForward />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div className="space-y-5">
                  <div className="animate-pulse bg-slate-200 w-36 h-5 rounded-full"></div>
                  <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    {Array.from({ length: 8 }).map((_, index) => {
                      return (
                        <div
                          key={index}
                          className="animate-pulse bg-slate-200 w-full h-48 rounded-md"
                        ></div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Blogs;
